(() => {
  const init = (root) => {
    root.querySelectorAll('[data-rack-gallery]').forEach((container) => {
      if (container.dataset.rackGalleryReady) return;
      const gallery = container.querySelector('media-gallery');
      const viewer = gallery?.querySelector('[id^="GalleryViewer-"]');
      const arrows = [container.querySelector('[data-rack-gallery-prev]'), container.querySelector('[data-rack-gallery-next]')];
      if (!gallery || !viewer || arrows.some((arrow) => !arrow)) return;

      const pending = new WeakMap();
      const prepareImage = (image, priority = 'low') => {
        if (!image) return Promise.resolve();
        if (priority === 'high' || image.fetchPriority !== 'high') image.fetchPriority = priority;
        image.decoding = 'async';
        image.loading = 'eager';
        if (!pending.has(image)) {
          const ready = image.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                const finish = () => {
                  image.removeEventListener('load', finish);
                  image.removeEventListener('error', finish);
                  resolve();
                };
                image.addEventListener('load', finish);
                image.addEventListener('error', finish);
              });
          pending.set(image, ready.then(() => image.decode?.()).catch(() => {}));
        }
        return pending.get(image);
      };
      const getItems = () => [...gallery.querySelectorAll('.product__media-list > [data-media-id]')];
      const getImage = (item) => item?.querySelector('.product__media img');
      const connection = navigator.connection;
      const limitedConnection = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
      let queue = [];
      let warming = false;
      let started = false;
      const warm = async () => {
        if (warming || !started) return;
        warming = true;
        while (queue.length && container.isConnected) {
          await prepareImage(queue.shift());
        }
        warming = false;
      };
      const queueAround = (item) => {
        const items = getItems();
        const current = Math.max(0, items.indexOf(item));
        const ordered = [items[(current + 1) % items.length], items[(current - 1 + items.length) % items.length]];
        if (!limitedConnection) ordered.push(...items.slice(current + 2), ...items.slice(0, current));
        queue = [...new Set(ordered.map(getImage).filter((image) => image && !pending.has(image)))];
        warm();
      };
      const first = getImage(viewer.querySelector('.is-active') || getItems()[0]);
      prepareImage(first, 'high').then(() => {
        started = true;
        queueAround(viewer.querySelector('.is-active') || getItems()[0]);
      });
      gallery.addEventListener('rack:media-change', (event) => queueAround(event.detail.media));
      const prepareTarget = (event) => {
        const target = event.target.closest('[data-target]');
        if (!target || !gallery.contains(target)) return;
        const item = getItems().find((item) => item.dataset.mediaId === target.dataset.target);
        prepareImage(getImage(item), 'high');
      };
      ['pointerover', 'pointerdown', 'focusin'].forEach((event) => gallery.addEventListener(event, prepareTarget));

      arrows.forEach((arrow, direction) => {
        viewer.append(arrow);
        const getNext = () => {
          const items = getItems();
          const current = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
          return items[(current + (direction === 0 ? -1 : 1) + items.length) % items.length];
        };
        ['pointerenter', 'focus', 'pointerdown'].forEach((event) =>
          arrow.addEventListener(event, () => prepareImage(getImage(getNext()), 'high'))
        );
        arrow.addEventListener('click', () => {
          if (getItems().length < 2) return;
          const next = getNext();
          const thumbnail = gallery.querySelector(`[data-target="${next.dataset.mediaId}"] button`);
          if (thumbnail) thumbnail.click();
          else gallery.setActiveMedia(next.dataset.mediaId, false);
        });
      });
      container.dataset.rackGalleryReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
